// extracted by mini-css-extract-plugin
export var quillEditor = "_jt-1";
export var variable = "_jt-0";